const main = {
    margin: '0',
    display: 'grid',
    padding: '0',
    height: {
        mobile: '100%',
    },
};
const mainContent = (isTabletOrMobile) => {
    return {
        display: 'flex',
        height: '100%',
        backgroundColor: {
            desktop: isTabletOrMobile ? '#FFFFFF' : '#E4EEEF',
            mobile: '#E4EEEF',
        },
    };
};
const decorationWrapper = (isTabletOrMobile, asStandAlonePage) => {
    return {
        display: 'flex',
        minWidth: asStandAlonePage ? '100%' : '50%',
        backgroundColor: isTabletOrMobile || asStandAlonePage ? '#FFFFFF' : '#E4EEEF',
        justifyContent: 'center',
    };
};
const imageContainer = {
    top: '-1rem',
    position: 'relative',
};
const bottom = {
    display: 'flex',
    flexDirection: {
        desktop: 'row',
        mobile: 'column',
    },
    justifyContent: 'space-between',
    width: '100%',
    '& .MuiButton-root': {
        width: {
            desktop: '192px',
            mobile: '100%',
        },
    },
    '& .MuiTypography-root': {
        alignSelf: 'flex-end',
        margin: {
            desktop: '1rem 0',
            mobile: '1rem 0',
        },
    },
};
const cardHeader = {
    width: '100%',
    display: 'flex',
    padding: {
        desktop: '40px 80px',
        mobile: '24px',
    },
};
export default {
    cardHeader,
    imageContainer,
    bottom,
    main,
    mainContent,
    decorationWrapper,
};
